(function(app) {

    app.config([
        "$stateProvider", "$urlRouterProvider", function($stateProvider, $urlRouterProvider) {
            $stateProvider.state("Home.404",
                {
                    component: "pageNotFound",
                    data: {
                        pageTitle: "Page not found"
                    }
                });

            $urlRouterProvider.otherwise(function($injector, $location) {
                var state = $injector.get("$state");
                state.go("Home.404");
                return $location.path();
            });
        }
    ]);

    app.component("pageNotFound",
        {
            templateUrl: "/App/404/404-template.html"
        });

    app.run([
        "$transitions", "$state", function($transitions, $state) {
            $transitions.onError({ to: "**", from: "**" },
                function (trans) {
                    var error = trans.error();

                    if (error.type !== 2 && //transition was superseded, most commonly via a redirect
                        error.type !== 5 && //transition was ignored, ie. user clicked on a link to a state they are already in
                        error.detail.status !== 401 &&
                        trans.$from().name !== "Home.404")
                        $state.go("Home.404");
                });
        }
    ]); 

})(window.app); //jshint ignore:line